module.exports = __webpack_public_path__ + "flyer_background_gifts_080-a0a2b14a36519fb34292a0cd94f09855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_gifts_080.jpg
// module id = 1651
// module chunks = 1